import React from "react";
import { MagnifyingGlass, PencilSimple} from "phosphor-react";
import NewHeader from "../helper/NewHeader";

function LanguageListTwo() {
  return (
    <>
      <NewHeader/>
      <main role="main" className="contentarea">
        <div className="container pt-4">
          <div className="searchForm ">
            <select className="selectLang">
              <option value="0">Select Language</option>
              <option value="1">english</option>
            </select>
            <input type="text" name="search" placeholder="Enter New word" />
            <button className="searchbtn">
              <MagnifyingGlass size={20} />
            </button>
          </div>
        </div>
        <section className="second pb-4">
          <div className="container">
            <div className="listTitle">
              <h2>Select by Subject:</h2>
            </div>
            <div className="bg-white borderRadi">
                <div className="d-flex justify-content-between editBtn">
                <div className="editBtn">
                <a href="javascript:void(0)" className="mr-3">EN</a>
                <a href="javascript:void(0)">example text</a>
                </div>
                <a href="javascript:void(0)">edit <PencilSimple size={20} /></a>                
            </div>
            <textarea name="text" id="" className="w-100 mt-2 borderLeft" rows="2" placeholder="meaning of the text"></textarea>
            </div>
            <div className="bg-white borderRadi green">
                <div className="d-flex justify-content-between editBtn">
                <div className="editBtn">
                <a href="javascript:void(0)" className="mr-3">EN</a>
                <a href="javascript:void(0)">example text</a>
                </div>
                <a href="javascript:void(0)">edit <PencilSimple size={20} /></a>                
            </div>
            <textarea name="text" id="" className="w-100 mt-2 borderLeft" rows="2"></textarea>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default LanguageListTwo;
